var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{attrs:{"id":"HistoryButton","title":"Vraćanje istorije"},on:{"click":_vm.HistoryButtonAction}},[_c('p',[_c('v-icon',{staticStyle:{"font-size":"48px"}},[_vm._v("keyboard_arrow_left")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }